import { dayjs } from "../services/dayjs";

export const getDefaultDate = (date: string | null | undefined) => {
    if(date) {
        const [year, month, day] = date.split("-");
        return dayjs(new Date(Number(year), Number(month)-1, Number(day)));
    }
    return null;
};
  


export const getDefaultDateNonNull = (date: string) => {
    const [year, month, day] = date.split("-");
    return dayjs(new Date(Number(year), Number(month)-1, Number(day)));
};
  